
import { useState } from "react";

const LoaderTopics = () => {
    const [heights] = useState(() =>
        Array.from({ length: 7 }, () => `${Math.floor(Math.random() * 80) + 80}px`)
    );

    return (
        <div className="main_geo_loader_container">
            <div className="loader_topics_container">
                {heights.map((height, index) => (
                    <div
                        key={index}
                        className="loader_topics_item_cont fade-in"
                        style={{ height }}
                    />
                ))}

            </div>
            <div className="text_btn_loader_cont">
                <div className="text_loader_cont">
                    <div className="text_loader_top fade-in"></div>
                    <div className="text_loader_bottom fade-in"></div>
                </div>
                <div className="btn_loader_cont">
                    <div className="btn_loader fade-in"></div>
                    <div className="btn_loader fade-in"></div>
                </div>
            </div>
        </div>
    );
};

export default LoaderTopics;
